<template>
	<div class="app-main">
		<SiteNavBar/>
		<section class="page-box"  :class="isCollapse ?'page-box-collapse':''">
			<head-main></head-main>
			<article class="page-main">
				<transition name="page" mode="out-in">
					<router-view></router-view>
				</transition>
			</article>
		</section>
		<!-- <SiteRightHelp></SiteRightHelp> -->
	</div>
</template>

<script>
import { mapState } from 'vuex'
import headMain from '@/pages/Layout/SiteHeader.vue'
import SiteNavBar from '@/pages/Layout/SiteNavBar.vue'
import SiteRightHelp from './Layout/SiteRightHelp'

export default {
	name: 'Main',
	data () {
		return {
		}
	},
	components: {
		headMain,
		SiteNavBar,
		// SiteRightHelp,
		// AccountActivation
	},
	created() {
		// console.log('this = ',this)
		this.showAlert()
	},
	computed: {
		...mapState(['isCollapse']),
	},
	methods: {
		showAlert() {
			(sessionStorage.getItem('isActivationShow') != 'false') ?  this.$toast('true') : ''
		},
	}
}

</script>

<style lang="scss" scoped>
.app-main{
	height: 100%;
	width: 100%;
	min-width: 1200px;
	overflow: hidden;
	position: relative;
	background-color: $colorE;
}
.page-box {
	margin-left: 160px;
	height: 100%;
	background:$colorE;
	&.page-box-collapse{
		-webkit-transition: all .28s;
		transition: all .28s;
		margin-left: 56px;
	}
	.page-main {
		padding: 76px 20px 20px;
		height: 100%;
		width: 100%;
		overflow-y: scroll;
		box-sizing: border-box;

	}
}
</style>
